export const blobToImage = (blob: Blob) => {
  const image = new Image()
  const url = URL.createObjectURL(blob)
  image.src = url
  return image
}
